import { render, staticRenderFns } from "./DeliveryInfo.vue?vue&type=template&id=4ae2d1e2&scoped=true"
import script from "./DeliveryInfo.vue?vue&type=script&lang=ts"
export * from "./DeliveryInfo.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryInfo.vue?vue&type=style&index=0&id=4ae2d1e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae2d1e2",
  null
  
)

export default component.exports